import { render, staticRenderFns } from "./Stagedetail.vue?vue&type=template&id=bee04c5c&scoped=true"
import script from "./Stagedetail.vue?vue&type=script&lang=js"
export * from "./Stagedetail.vue?vue&type=script&lang=js"
import style0 from "./Stagedetail.vue?vue&type=style&index=0&id=bee04c5c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bee04c5c",
  null
  
)

export default component.exports